import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { api_url } from "../../../../../../constants";
import FormGenerator from "../../../../../../Components/FormGenerator";
import {
  SetMentorProfile,
  UpdateMentorProfileError,
} from "./MentorProfileActions";
import { useLocation, useParams } from "react-router";
// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function MentorProfile(props) {
  const dispatch = useDispatch();
  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;
  const [feildIsMandatory, setFeildIsMandatory] = useState(
    !(userRole === "employee")
  );
  useEffect(() => {
    if (userRole === "employee") {
      setFeildIsMandatory(false);
    }
  }, []);

  const {
    role,
    overview,
    approach,
    background,
    representatitive_clients,
    education_and_qualifications,
    client_testimonials,
    language_lists,
    cli_expertises,
    expertise_areas,
    client_types,
    diagnostic_tools,
  } = useSelector((state) => state.mentorProfileReducer.data);

  const {
    // expertise_areas,
    // diagnostic_tools,
    // language_lists,
    // client_types,
    // cli_expertises
  } = useSelector((state) => state.commonReducer.employeeDropdowns);

  const errors = useSelector((state) => state.mentorProfileReducer.errors);

  const languageListSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.language_lists
  );
  const clientExpertiseSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.cli_expertises
  );
  const expertiseAreasSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.expertise_areas
  );
  const diagnosticToolsSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.diagnostic_tools
  );
  const clientTypeSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.client_types
  );

  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item) => {
      item.value === "" && (formData[item.name] = "");
      if (item.value || item.inputValue || item.selectValue) {
        item.value && (formData[item.name] = item.value);
        item.inputValue && (formData[item.inputName] = item.inputValue);
        item.selectValue && (formData[item.selectName] = item.selectValue);
        dispatch(SetMentorProfile(formData));
      }
    });
    dispatch(UpdateMentorProfileError(updatedForm[index].name));
  };

  // Form disabling
  const location = useLocation();
 
  let organisation_id = globaluserData?.organisation_id;
  let employee_id = globaluserData?.employee_id;
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }
  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };

  const formArray = [
    // {
    //   componentType: "input",
    //   type: "text",
    //   label: "Role*",
    //   helperText: errors.role && "Please enter a Role",
    //   name: "role",
    //   placeholder: "Role",
    //   handleChange: handleInputChange,
    //   value: role,
    // },
    {
      componentType: "imageUploadWithCrop",
      label: "Picture",
      // errorMsg: ".png, .jpg",
      existingImage: props.existingImage || null,
      setImageBlob: props.setImageBlob,
      // section: "org",
      cropProps: { unit: "%", width: 45, height: 40 },
      previewStyle: {
        width: "400px",
        height: "150px",
        borderRadius: 0,
      },
      imgPreviewProps: {
        width: "400px",
        height: "150px",
        style: {
          borderRadius: 0,
        },
      },
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory ? "Overview" : "Overview*",
      helperText: errors.overview && "Please enter a Overview",
      name: "overview",
      multiline: true,
      placeholder: "Overview",
      handleChange: handleInputChange,
      value: overview,
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory ? "Mentoring approach" : "Mentoring approach*",
      helperText: errors.approach && "Please enter a Mentoring Approach",
      name: "approach",
      multiline: true,
      placeholder: "Mentoring approach",
      handleChange: handleInputChange,
      value: approach,
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory ? "Background" : "Background*",
      helperText: errors.background && "Please enter a Background",
      name: "background",
      multiline: true,
      placeholder: "Background",
      handleChange: handleInputChange,
      value: background,
    },
    {
      componentType: "multiSelectChip",
      label: feildIsMandatory
        ? "Mentoring areas of expertise"
        : "Mentoring areas of expertise*",
      helperText:
        errors.expertise_areas && "Please enter a Mentoring Areas of expertise",
      name: "expertise_areas",
      placeholder: "Mentoring areas of expertise",
      handleChange: handleInputChange,
      value: expertise_areas,
      itemArr: expertiseAreasSelector,
      //   apiVariable: "diagnostic_tools",
      selectOptions: expertiseAreasSelector,
    },
    {
      componentType: "multiSelectChip",
      // type: "text",
      label: "Client specific areas of expertise",
      // helperText:
      //   errors.cli_expertises &&
      //   "Please enter a Client Specific Areas of Expertise",
      name: "cli_expertises",
      placeholder: "Client specific areas of expertise",
      handleChange: handleInputChange,
      value: cli_expertises,
      itemArr: clientExpertiseSelector,
      selectOptions: clientExpertiseSelector,
      dropDown: "CliExpertise",
      field_name: "client_specific_areas_of_expertise",
    },
    {
      componentType: "multiSelectChip",
      label: feildIsMandatory ? "Types of clients" : "Types of clients*",
      name: "client_types",
      value: client_types,
      placeholder: "Select types of clients",
      itemArr: clientTypeSelector,
      selectOptions: clientTypeSelector,
      handleChange: handleInputChange,
      helperText:
        errors && errors.client_types && "Please select a Types of Clients",
      // dropDown: "ClientType",
      // field_name: "client_type",
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory
        ? "Representative clients"
        : "Representative clients*",
      helperText:
        errors.representatitive_clients &&
        "Please enter a Representative Clients",
      name: "representatitive_clients",
      multiline: true,
      placeholder: "Representative clients",
      handleChange: handleInputChange,
      value: representatitive_clients,
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory
        ? "Education and qualifications"
        : "Education and qualifications*",
      helperText:
        errors.education_and_qualifications &&
        "Please enter a Education and Qualifications",
      name: "education_and_qualifications",
      multiline: true,
      placeholder: "Education and qualifications",
      handleChange: handleInputChange,
      value: education_and_qualifications,
    },
    {
      componentType: "multiSelectChip",
      label: feildIsMandatory ? "Languages" : "Languages*",
      name: "language_lists",
      value: language_lists,
      placeholder: "Select languages",
      selectOptions: languageListSelector,
      itemArr: languageListSelector,

      // apiVariable: "languages",
      handleChange: handleInputChange,
      helperText:
        errors && errors.language_lists && "Please select a languages list",
    },
    {
      componentType: "multiSelectChip",
      label: feildIsMandatory
        ? "Psychometric and diagnostic tools"
        : "Psychometric and diagnostic tools*",
      name: "diagnostic_tools",
      value: diagnostic_tools,
      placeholder: "Select psychometric and diagnostic tools",
      selectOptions: diagnosticToolsSelector,
      itemArr: diagnosticToolsSelector,
      handleChange: handleInputChange,
      helperText:
        errors &&
        errors.diagnostic_tools &&
        "Please select a Psychometric and Diagnostic Tools",
      // dropDown: "DiagnosticTool",
      // field_name: "diagnostic_tool",
    },
    {
      componentType: "input",
      type: "text",
      label: feildIsMandatory ? "Client testimonials" : "Client testimonials*",
      helperText:
        errors.client_testimonials && "Please enter  Client Testimonials",
      name: "client_testimonials",
      multiline: true,
      placeholder: "Client testimonials",
      handleChange: handleInputChange,
      value: client_testimonials,
    },
  ];

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  return (
    <FormGenerator
      children={formInput.map(formDisabler)}
      submitURL={api_url.organisation}
      handleNext={props.handleNext}
      nextIndex={2}
      setId={props.setId}
    />
  );
}
